module.exports = __webpack_public_path__ + "img/demo_1.f595bfbe.png";